<template>
  <div v-if="show" class="popup cantact" @click="closePopup">
    <div class="popup-container">
      <div class="popup-header">
        <h2></h2>
        <button class="icon close" @click.stop="show = false"></button>
      </div>
      <div class="popup-body">
        <h1 v-text="$t('customer_center.tel_number')"></h1>
        <p>
          <strong v-text="$t('footer.business_hour')"></strong> :
          {{ $t('customer_center.business_hours') }}
        </p>
        <p>
          <strong v-text="$t('footer.fax_number')"></strong> :
          {{ $t('customer_center.fax') }}
        </p>
        <p>
          <strong v-text="$t('common.t_email')"></strong> :
          {{ $t('customer_center.email') }}
        </p>
        <br />
        <p>
          <strong v-text="$t('footer.no_business_hour_desc')"></strong>
        </p>
        <p v-text="$t('customer_center.email')"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupGuide',
  props: {
    opened: false,
  },
  computed: {
    show: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) {
          this.$emit('popupOff');
        }
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    closePopup(e) {
      this.show = e.target.className !== 'popup contact';
    },
  },
};
</script>

<style scoped lang="scss">
.popup.cantact {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-container {
    width: 400px;
    background-color: $white;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;

    .popup-header {
      width: 100%;
      height: 56px;
      padding: 0 16px;
      border-bottom: 1px solid $gray-eb;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 14px;
        color: $gray-33;
      }

      .icon.close {
        width: 15px;
        height: 15px;
        margin: auto 0;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        background-image: url(~@assets/images/icon-close.png);
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
      }
    }

    .popup-body {
      width: 100%;
      font-size: 13px;
      padding-top: 20px;
      padding-bottom: 30px;

      h1 {
        width: 100%;
        color: $primary;
        text-align: center;
        font-size: 30px;
        height: 100%;
        padding-top: 10px;
        padding-bottom: 20px;
      }

      p {
        font-size: 13px;
        text-align: center;
        line-height: 150%;
        color: $gray-48;
        letter-spacing: 0.5px;
      }

      strong {
        font-size: 13px;
        color: $gray-66;
      }
    }

    .popup-footer {
      width: 100%;
      padding-top: 5px;
      padding-bottom: 17px;

      .button-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .button {
          width: 56px;
          height: 28px;
          font-size: 11px;
          -webkit-border-radius: 16px;
          -moz-border-radius: 16px;
          border-radius: 16px;
        }

        .button + .button {
          margin-left: 24px;
        }
      }
    }
  }

  &.guide {
    .popup-container {
      min-width: 800px;
      width: 75%;
      height: 80%;
      min-height: 600px;

      .popup-body {
        height: calc(100% - 144px);
      }
    }
  }
}
</style>
